export const categories = [
	{ id: "1", value: "paintings", label: "Paintings" },
	{ id: "2", value: "drawings", label: "Drawings" },
	{ id: "3", value: "mixmedia", label: "Mixed Media" },
];
